/* ============================================================
   DABOSKYN — daboskyn.js
   Bundle Builder · Cart API · Sticky Bar · Countdown (shared)
   Gallery Dots
   ============================================================ */

/* ── Gallery Dots ─────────────────────────────────────────── */
(function () {
  'use strict';

  function initGalleryDots(dotsContainer) {
    var galleryId = dotsContainer.dataset.galleryId;
    var sliderComponent = document.getElementById(galleryId);
    if (!sliderComponent) return;

    var slider = sliderComponent.querySelector('.product__media-list');
    if (!slider) return;

    var dots = dotsContainer.querySelectorAll('.db-gallery-dots__dot');
    if (!dots.length) return;

    function setActive(index) {
      dots.forEach(function (d, i) {
        d.classList.toggle('db-gallery-dots__dot--active', i === index);
      });
    }

    /* Sync from slider scroll */
    slider.addEventListener('scroll', function () {
      var slideWidth = slider.offsetWidth;
      if (!slideWidth) return;
      var index = Math.round(slider.scrollLeft / slideWidth);
      setActive(index);
    }, { passive: true });

    /* Sync from Dawn's slider-component custom events */
    sliderComponent.addEventListener('slideChanged', function (e) {
      if (e.detail && typeof e.detail.currentPage !== 'undefined') {
        setActive(e.detail.currentPage - 1);
      }
    });

    /* Also observe aria-current changes on slides (Dawn updates these) */
    var slides = slider.querySelectorAll('.slider__slide');
    if (slides.length) {
      var observer = new MutationObserver(function () {
        slides.forEach(function (slide, i) {
          if (slide.classList.contains('is-active')) setActive(i);
        });
      });
      slides.forEach(function (slide) {
        observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
      });
    }

    /* Click on dot → scroll slider */
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var slideWidth = slider.offsetWidth;
        slider.scrollTo({ left: slideWidth * i, behavior: 'smooth' });
        setActive(i);
      });
    });
  }

  function initAllGalleryDots() {
    document.querySelectorAll('.db-gallery-dots').forEach(initGalleryDots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllGalleryDots);
  } else {
    initAllGalleryDots();
  }
})();

/* ── 1. Bundle Builder ───────────────────────────────────── */
(function () {
  'use strict';

  function initBundleBuilder(wrapper) {
    var sectionId      = wrapper.dataset.section;
    var radios         = wrapper.querySelectorAll('.db-price-card__radio');
    var labels         = wrapper.querySelectorAll('.db-price-card');
    var priceContainer = document.getElementById('price-' + sectionId);

    if (!radios.length) return;

    /* ── Sincroniza el bloque de precio nativo de Dawn ── */
    function syncPrice(radio) {
      var label = wrapper.querySelector('label[for="' + radio.id + '"]');
      if (!label) return;

      var price        = label.dataset.price || '';
      var comparePrice = label.dataset.comparePrice || '';
      var onSale       = label.dataset.onSale === 'true';
      var available    = label.dataset.available !== 'false';

      if (priceContainer) {
        var priceRoot = priceContainer.querySelector('.price');
        if (priceRoot) {
          priceRoot.classList.toggle('price--on-sale',  onSale);
          priceRoot.classList.toggle('price--sold-out', !available);
        }

        /* Precio de venta (visible cuando hay descuento) */
        var salePriceEl = priceContainer.querySelector('.price__sale .price-item--sale');
        if (salePriceEl && price) salePriceEl.textContent = price;

        /* Tachado precio original */
        var compareEl = priceContainer.querySelector('.price__sale .price-item--regular');
        if (compareEl && comparePrice) compareEl.textContent = comparePrice;

        /* Precio regular (visible sin descuento) */
        var regularEl = priceContainer.querySelector('.price__regular .price-item--regular');
        if (regularEl && price) regularEl.textContent = price;
      }
    }

    /* ── Sincroniza la variante seleccionada con EasySell COD Form ──
       EasySell auto-detecta el variant id leyendo input[name="id"] del
       product form. Actualizamos todos los inputs del DOM y disparamos
       eventos estándar para que la app reaccione. */
    function syncVariantToShopify(variantId) {
      var idInt = parseInt(variantId, 10);
      if (!idInt) return;

      document.querySelectorAll('input[name="id"]').forEach(function (input) {
        input.value = String(idInt);
        input.dispatchEvent(new Event('input',  { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      document.dispatchEvent(new CustomEvent('variant:change', {
        bubbles: true,
        detail: { variant: { id: idInt } }
      }));
    }

    /* ── Selección de tier ── */
    function selectTier(radio) {
      labels.forEach(function (l) { l.classList.remove('db-price-card--selected'); });
      var label = wrapper.querySelector('label[for="' + radio.id + '"]');
      if (label) label.classList.add('db-price-card--selected');
      syncPrice(radio);
      syncVariantToShopify(radio.value);
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () { selectTier(this); });
    });

    /* Activar el que ya viene checked (default_selected) y sincronizar precio + variante inicial */
    var checked = wrapper.querySelector('.db-price-card__radio:checked');
    if (checked) selectTier(checked);
  }

  function mountBundles() {
    document.querySelectorAll('.db-bundle').forEach(initBundleBuilder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountBundles);
  } else {
    mountBundles();
  }

  /* Re-init en Shopify Design Mode (cambio de sección en customizer) */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    if (section) {
      section.querySelectorAll('.db-bundle').forEach(initBundleBuilder);
    }
  });

})();


/* ── 2. Countdown Timer (reutilizable global) ─────────────── */
(function () {
  'use strict';

  /*
   * DaboskynCountdown — inicializa cualquier .db-countdown en la página
   * que NO haya sido ya inicializado por el inline script de countdown-timer-bar.
   * Usado por pricing-standalone y otros que incluyen el snippet directamente.
   */
  function initCountdown(el) {
    if (el.dataset.dbTimerInit) return;
    el.dataset.dbTimerInit = '1';

    var timerId   = el.id;
    var resetHours = parseInt(el.dataset.resetHours || '24', 10);
    var lsKey     = 'db_countdown_' + (timerId || 'default');

    function getDeadline() {
      var stored = localStorage.getItem(lsKey);
      var deadline;
      if (stored) {
        deadline = parseInt(stored, 10);
        if (isNaN(deadline) || deadline <= Date.now()) {
          deadline = Date.now() + resetHours * 3600000;
          localStorage.setItem(lsKey, deadline);
        }
      } else {
        deadline = Date.now() + resetHours * 3600000;
        localStorage.setItem(lsKey, deadline);
      }
      return deadline;
    }

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick(deadline) {
      var diff = Math.max(0, deadline - Date.now());
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);

      var hEl = el.querySelector('[data-unit="hours"]');
      var mEl = el.querySelector('[data-unit="minutes"]');
      var sEl = el.querySelector('[data-unit="seconds"]');
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);

      if (diff <= 0) {
        var newDeadline = Date.now() + resetHours * 3600000;
        localStorage.setItem(lsKey, newDeadline);
        setTimeout(function () { tick(newDeadline); }, 1000);
        return;
      }
      setTimeout(function () { tick(deadline); }, 1000);
    }

    tick(getDeadline());
  }

  function mountCountdowns() {
    document.querySelectorAll('.db-countdown').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountCountdowns);
  } else {
    mountCountdowns();
  }

  document.addEventListener('shopify:section:load', mountCountdowns);
})();


/* ── 3. Sticky Buy Bar (producto) ────────────────────────── */
(function () {
  'use strict';

  function initStickyBar() {
    var bar      = document.getElementById('db-sticky-bar');
    var sentinel = document.getElementById('db-pricing-sentinel');
    if (!bar) return;

    if (!sentinel) {
      bar.classList.add('db-sticky-bar--visible');
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('db-sticky-bar--visible', !entry.isIntersecting);
      });
    }, { threshold: 0.1 });

    io.observe(sentinel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyBar);
  } else {
    initStickyBar();
  }

  document.addEventListener('shopify:section:load', initStickyBar);
})();


/* ── 4. Header scroll blur ───────────────────────────────── */
(function () {
  'use strict';

  function initHeaderScroll() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        header.classList.toggle('scrolled', window.scrollY > 10);
        ticking = false;
      });
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderScroll);
  } else {
    initHeaderScroll();
  }
})();
